/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_box_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste one numeric column per group to build box-and-whisker plots. Each box shows the median, the interquartile range and the full spread, making it easy to compare groups.`)
};

const es_box_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una columna numérica por grupo para crear diagramas de caja y bigotes. Cada caja muestra la mediana, el rango intercuartílico y la dispersión completa, facilitando la comparación entre grupos.`)
};

const de_box_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie eine numerische Spalte pro Gruppe ein, um Box-Whisker-Diagramme zu erstellen. Jede Box zeigt den Median, den Interquartilsabstand und die volle Spannweite, wodurch der Vergleich von Gruppen erleichtert wird.`)
};

const nl_box_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak één numerieke kolom per groep om box-and-whiskerplots te bouwen. Elke box toont de mediaan, het interkwartielbereik en de volledige spreiding, waardoor groepen eenvoudig te vergelijken zijn.`)
};

const fr_box_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une colonne numérique par groupe pour créer des boîtes à moustaches. Chaque boîte montre la médiane, l'intervalle interquartile et l'étendue complète, ce qui facilite la comparaison des groupes.`)
};

const it_box_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una colonna numerica per gruppo per costruire box plot a scatola e baffi. Ogni scatola mostra la mediana, l'intervallo interquartile e l'intera dispersione, rendendo facile confrontare i gruppi.`)
};

const pt_br2_box_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma coluna numérica por grupo para criar diagramas de caixa (boxplots). Cada caixa mostra a mediana, a amplitude interquartil e a dispersão total, facilitando a comparação entre grupos.`)
};

const pt_box_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma coluna numérica por grupo para construir diagramas de extremos e quartis. Cada caixa mostra a mediana, a amplitude interquartil e a dispersão total, facilitando a comparação entre grupos.`)
};

const ja_box_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループごとに1つの数値列を貼り付けると箱ひげ図が作成されます。各箱は中央値、四分位範囲、全範囲を示し、グループ間の比較が容易になります。`)
};

const zh_box_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每组粘贴一列数值以构建箱须图。每个箱子显示中位数、四分位距和完整分布范围，便于比较各组数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const box_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.box_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("box_intro", locale)
	if (locale === "en") return en_box_intro(inputs)
	if (locale === "es") return es_box_intro(inputs)
	if (locale === "de") return de_box_intro(inputs)
	if (locale === "nl") return nl_box_intro(inputs)
	if (locale === "fr") return fr_box_intro(inputs)
	if (locale === "it") return it_box_intro(inputs)
	if (locale === "pt-BR") return pt_br2_box_intro(inputs)
	if (locale === "pt") return pt_box_intro(inputs)
	if (locale === "ja") return ja_box_intro(inputs)
	return zh_box_intro(inputs)
};